import script from "./SkipNavigationLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkipNavigationLink.vue?vue&type=script&lang=ts&setup=true"

import "./SkipNavigationLink.vue?vue&type=style&index=0&id=3ba32ab8&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ba32ab8"]])

export default __exports__